import { style } from "@vanilla-extract/css";
import { vars } from "../../../../styles/theme.css";

export const broadcasterLink = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.xs,
  borderRadius: vars.radii.xs,
  backgroundColor: vars.colors.onPrimaryFixed,
  padding: `0 ${vars.space.xs}`,
  height: "2.6rem",
  textDecoration: "none",
  color: vars.colors.primaryFixed,
  fontSize: 8,
});
